<template>
  <c-sidesheet class="mass-operations-sidesheet" id="type-modal" :active="displayModal" @close="close">

    <div v-show="!isLoadingData" class="modal-frame">
      <div class="modal-wrapper">
        <shadow-scroll-container ref="track" class="modal-track" :with-top-scroller="true">
          <div class="modal-track__wrapper">
            <div class="modal-frame__header">
              <h2 class="modal-frame__title">Исполнители</h2>

              <c-input
                class="modal-frame__list-search"
                v-model="search"
                placeholder="Поиск по ФИО"
                :clearable="true"
                icon="search"
                @enter="updateList"
              />

              <div v-if="workers.length" class="modal-frame__info">
                <div @click="changeCheckboxAll">
                  <c-switcher v-model="checkboxAll" label="Выбрать всех" class="modal-frame__checkbox" type="checkbox" :middlePosition="middlePositioncheckboxAll"  />
                </div>

                <div class="modal-frame__counter"><span>Выбрано:</span> {{ checkedWorkersCounter }} из {{ workersTotalCount }}</div>
              </div>
            </div>

            <div class="modal-frame__list">
              <div v-for="worker in workers" :key="worker.id" class="modal-frame__worker">
                <c-switcher v-model="worker.checked" class="modal-frame__checkbox" type="checkbox"  />

                <div v-viewer class="modal-frame__worker-photo">
                  <div class="svg-wrapper">
                    <svg-icon
                      name="eye"
                      :size="32"
                      color="white"
                    ></svg-icon>
                  </div>
                  <img :src="`${worker.photo ? worker.photo : '/redesign/img/userpic.svg'}`" width="34" height="34" />
                </div>

                <div class="modal-frame__worker-text">
                  <div class="modal-frame__worker-name">{{ worker.fio }}</div>
                  <div v-for="post in worker.posts" class="modal-frame__worker-posts">{{ post.typePost_name + " / " + post.post_name + " / " + post.specialty_name + " / " + post.rank_number }}</div>
                  <div class="modal-frame__worker-filial">{{ worker.filial_name }}</div>
                </div>
              </div>

              <!-- <div v-if="!workersList.length" class="modal-frame__list-empty">
                Не выбрано сотрудников для действий
              </div> -->
              <div v-if="!workers.length" class="modal-frame__list-empty">
                Нет исполнителей с заданными параметрами
              </div>

              <c-loader
                v-if="isLoadingData || isLoading"
                label="Данные загружаются"
                :active="isLoadingData || isLoading"
                :height="'400'"
              />

              <div class="modal-frame__actions" :class="{'modal-frame__actions--fixed': actionsIsFixed}">
                <c-button class="modal-frame__action" label="Отменить" size="large" @click="close" />
                <c-button class="modal-frame__action" label="Сохранить" size="large" color="primary" @click="submit" />
              </div>
            </div>
          </div>
        </shadow-scroll-container>
      </div>
    </div>

    <transition name="fade">
      <display-shown-items-count
        v-if="!isLoadingData && displayModal"
        :total-items-count="workersTotalCount"
        :shown-items-count="workers.length"
      />
    </transition>

    <!-- <top-button root=".layout"></top-button> -->

  </c-sidesheet>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CInput from "@/components/controls2/Input";
import CTextarea from "@/components/textarea";
import CButton from "@/components/controls2/Button";
import Button1 from "@/components/controls/button";
import CCheckbox from "@/components/checkbox";
import CSidesheet from "@/components/sidesheet";
import MConfirm from "@/components/modals/confirm-modal";
import FileLoader from "@/components/file-loader";
import TopButton from "@/components/top-button";
import ShadowScrollContainer from "@/components/shadow-scroll-container";
import Input2 from "@/components/controls2/Input";
import Switcher from "@/components/controls/switcher";
import Select2 from "@/components/controls2/Select";
import { FineReasonDescription } from "@/entities/models/fine-reason";
import ShowDescription from "@/components/show-description";
import Loader from "@/components/loader";
import SvgIcon from "@/components/svg-icon";
import DataTable from "@/pages/calculation-sheets/calculation-sheet/additions/data-table";
import { AccountOperation } from "@/entities/models/account-operation";
import VacationModal from "@/pages/financial-transactions/components/vacation-modal";
import newTransactionModal from "@/pages/calculation-sheets/calculation-sheet/additions/new-transaction-modal";
import WorkerOrUser from "@/components/user/worker-or-user";
import { onScrollEnd } from "@/helpers/events";
import DisplayShownItemsCount from "@/components/display-shown-items-count";

import noAvatarImg from "@/assets/images/userpic.svg";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

export default {
  name: "mass-operations-sidesheet-step-1",
  components: {
    CInput,
    CTextarea,
    CButton,
    "c-button-1": Button1,
    CCheckbox,
    CSidesheet,
    MConfirm,
    FileLoader,
    TopButton,
    ShadowScrollContainer,
    "c-input-2": Input2,
    "c-switcher": Switcher,
    "c-select-2": Select2,
    ShowDescription,
    "c-loader": Loader,
    SvgIcon,
    "c-data-table": DataTable,
    VacationModal,
    newTransactionModal,
    WorkerOrUser,
    DisplayShownItemsCount
  },
  props: ["isLoading"],
  mounted() {
    const layout = document.querySelector(".mass-operations-sidesheet .scroll-container");
    layout.addEventListener("scroll", this.handleLayoutScroll);
  },

  beforeDestroy() {
    const layout = document.querySelector(".mass-operations-sidesheet .scroll-container");
    if (layout) layout.removeEventListener("scroll", this.handleLayoutScroll);
  },
  async created() {
    document.addEventListener("click", (e) => {
      if (e.target.closest('.close-popover')) {
        this.$root.$emit("bv::hide::popover");
      }
    });

    let flag = true;

    let interval = setInterval(() => {
      if (flag) {
        let scrollContainerContent = document.querySelector('.mass-operations-sidesheet .scroll-container__content');

        if (scrollContainerContent) {
          if (scrollContainerContent.scrollHeight > document.documentElement.clientHeight) {
            this.actionsIsFixed = true
            flag = false;
            clearInterval(interval)
          } else {
            this.actionsIsFixed = false
          }
        }
      }
    }, 100);
  },
  data() {
    return {
      displayModal: false,
      isLoadingData: false,
      actionsIsFixed: false,

      search: "",

      records: null,
      currentSheet: null,

      workersList: [],
      filteredWorkersList: [],
    };
  },
  computed: {
    ...mapState({
      workers: (state) => state.functions.workers,
      workersTotalCount: (state) => state.functions.workersTotalCount,
      functionModel: (state) => state.functions.functionModel,
      defaultPerformers: (state) => state.functions.defaultPerformers,
    }),
    checkboxAll: {
      get() {
        return this.$store.state.functions.checkboxAllWorkers;
      },
      set(value) {
        this.$store.commit("functions/setCheckboxAll", value);
      },
    },
    middlePositioncheckboxAll() {
      return this.checkedWorkersCounter !== 0 && this.checkedWorkersCounter !== this.workersTotalCount
    },
    checkedWorkers() {
      let array = [...this.workers.filter(worker => worker.checked)];

      if (this.defaultPerformers && this.defaultPerformers.length) {
        this.defaultPerformers.forEach(worker => {
          let findedWorker = this.workers.find(workerInList => workerInList.id === worker.id);
          if (!findedWorker) {
            array.push(worker)
          }
        })
      }

      return array
    },
    checkedWorkersCounter() {
      return this.checkboxAll ? this.workersTotalCount : this.checkedWorkers.length
    }
  },
  methods: {
    async open(records, currentSheet) {
      this.displayModal = true;

      // this.records = records;
      // this.currentSheet = currentSheet;

      // await this.getData();
      this.$refs.track.update();
    },

    close() {
      this.displayModal = false;
      this.workersList = [];
      this.filteredWorkersList = [];
      this.search = "";
//      this.updateList();
  //    this.$emit('reset-workers')
    },

    submit() {
      this.search = "";
      this.updateList();
      this.displayModal = false;
      console.log("submit end")
    },

    async getData() {
      this.isLoadingData = true;

      this.records.forEach((record, i) => {
        this.$store.dispatch("financialTransactions/getWorkerById", Number(record.worker.worker.id)).then(res => {
          if (res) {
            this.workersList.push(
              {
                id: res.id,
                photo: res.photo, 
                name: res.fio, 
                filial: record.filial.value, 
                filial_id: record.filial_id.value, 
                post: record.post.value,
                post_code: record.post_code.value,
                value: record.worker.worker.id,
                label: res.fio,
                worker: record.worker,
                record_id: record.record_id
              }
            )
            
          }
          if (i === this.records.length - 1) {
            this.filteredWorkersList = this.workersList;
            this.isLoadingData = false;
          }
        })
      })
    },

    onScroll(scrollTop) {
      this.scrolled = scrollTop > 150;
    },

    deleteWorkerFromList(recordId) {
      this.workersList = this.workersList.filter(worker => Number(worker.record_id) !== Number(recordId))
      this.filteredWorkersList = this.filteredWorkersList.filter(worker => Number(worker.record_id) !== Number(recordId))
      this.records = this.records.filter(record => Number(record.record_id) !== Number(recordId))
      this.$emit('delete-record-from-selected-list', recordId)
    },

    goToNextStep() {
      this.$emit('go-to-next-step', this.records, this.currentSheet)
    },

    replaceImageOnErrorLoad(e) {
      e.target.src = this.noAvatarImg;
    },

    changeCheckboxAll() {
      // console.log(this.checkboxAll)
      setTimeout(() => {
        this.workers.forEach(worker => {
          worker.checked = this.checkboxAll
        })
      }, 0);
    },

    handleLayoutScroll() {
      const layout = document.querySelector(".mass-operations-sidesheet .scroll-container");
      const contentHeight = layout.offsetHeight;
      const yOffset = layout.scrollHeight - layout.scrollTop;

      if (yOffset - 5 <= contentHeight) {
        this.$emit('goToNextPage', this.search)
      }
    },
    updateList() {
      this.$emit('updateList', this.search);
    }
  },
  watch: {
    search() {
      this.filteredWorkersList = this.workersList.filter(worker => worker.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
    },
    workers: {
      handler() {
        if (this.workers.length === this.workers.filter(worker => worker.checked).length) {
          this.checkboxAll = true;
        } else {
          this.checkboxAll = false;
        }

        // this.$emit('updateCheckedList', this.workers.filter(worker => worker.checked))
      },
      deep: true
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

::v-deep {
  .sidesheet {
    &__header {
      display: none;
    }
    &__wrapper {
      padding: 0 !important;
      z-index: 1001;
    }

    &__content {
      height: 100%;
      padding: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    &__close {
      padding-right: 10px;
      padding-top: 10px;
    }
  }

  .loader-overlay {
    border: unset;
  }
}

.modal-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .col {
    margin-bottom: 30px;
  }

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 565px;
    margin-top: 26px;
  }

  &__checkbox {
    width: auto;

    /deep/ {
      .c-switcher {
        margin: 0;
      }
    }
  }

  &__counter {
    font-size: 13px;
    line-height: 120%;

    span {
      color: #8E9CBB;
    }
  }

  &__worker {
    display: flex;
    align-items: center;

    &-delete {
      background-color: unset;
      border: unset;
      margin-right: 16px;
    }
    &-photo {
      margin-right: 10px;
      position: relative;
      cursor: pointer;
      border-radius: 50%;
      overflow: hidden;
      width: 34px;
      height: 34px;

      .svg-wrapper {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        pointer-events: none;
        left: 0;
        background: rgba(0,0,0,.7);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: .2s ease-in-out;
      }

      &:hover {
        .svg-wrapper {
          opacity: 1;
        }
      }
    }
    &-text {
      font-size: 15px;
      line-height: 110%;
    }
    &-name {
      color: var(--turn-on, #06F);
      font-weight: 500;
    }
    &-posts {
      font-size: 13px;
      line-height: 120%;
    }
    &-filial {
      font-size: 13px;
      line-height: 120%;
      color: #8E9CBB;
    }
  }

  &__transaction-type {
    font-size: 15px;
    line-height: 18px;

    &-name {
    }
    &-description {
    }
  }

  /deep/ {
    .c-select-required {
      position: static;
      margin-top: 5px;
    }

    .c-select__input.c-select__input_required {
      &:focus {
        border-color: #ff238d;
      }
    }

    .scroll-container {
      padding: 0 30px 35px;

      @include vp-767 {
        padding: 30px 20px;
      }
    }
  }
  
  .h-switcher {
    /deep/ {
      .c-switcher-group {
        display: flex;
      }
    }
  }

  .modal-wrapper {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
  }

  .modal-track {
    width: 100%;
    height: 100%;

    /deep/ {
      .scroll-container {
        padding-right: 0;
      }
    }
  }

  .modal-actions {
    flex-shrink: 0;
    background: white;
    display: none;

    & button {
      flex-basis: 100%;
      width: 100%;
      border-radius: 0;
      flex-shrink: 1;
    }

    @include vp-767 {
      display: flex;
    }
  }

  .form-group {
    max-width: 564px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 25px;

    &__column {
      width: 100%;
      position: relative;

      &--2 {
        width: calc((100% - 25px) / 2);
        
        &:not(:last-child) {
          margin-right: 25px;
        }

        @include vp-767 {
          width: 100%;

          &:not(:last-child) {
            margin-right: 0;
            margin-bottom: 25px;
          }
        }
      }

      &--3 {
        width: calc((100% - 25px * 2) / 3);
        
        &:not(:last-child) {
          
          margin-right: 25px;
        }

        @include vp-767 {
          width: 100%;

          &:not(:last-child) {
            margin-right: 0;
            margin-bottom: 25px;
          }
        }
      }
    }

    &__item-description {
      position: absolute;
      top: 50%;
      right: -40px;
      transform: translateY(-50%);

      &.c-button_icon_info-new {
        border: unset;
        padding: 0;
        font-size: 13px;
        color: $color-primary;
        align-items: center;

        /deep/ {
          .c-button-label {
            margin-top: 4px;
          }
        }
      }

      &--mobile {
        display: none;
      }

      &--desktop {
        margin: 4px 0 0;

        /deep/ {
          .c-button-icon {
            transform: translate(-50%, -50%);
          }
        }
      }


      @include vp-767 {
        position: relative;
        transform: unset;
        top: unset;
        right: unset;
        margin-top: 15px;

        &--desktop {
          display: none;
        }

        &--mobile {
          display: flex;
          height: fit-content;
        }
      }
    }
  }

  &__header {
    margin-bottom: 10px;
  }

  &__title {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 500;
  }

  &__actions {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    margin-top: 25px;

    &--fixed {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 10px 25px;
      background-color: #FFFFFF;
      width: 100%;
      box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
    }

    @include vp-767 {
      display: none;
    }
  }

  &__action {
    &:not(:last-child) {
      margin-right: 10px;
    }
  }

  @include bootstrapMd {
    &__header {
      display: flex;
      flex-direction: column;
      position: sticky;
      top: 0;
      background-color: #FFFFFF;
      z-index: 1;
      padding-top: 35px;
      padding-bottom: 25px;

      &::before {
        content: '';
        position: absolute;
        bottom: -20px;
        left: 0;
        width: 100%;
        height: 20px;
        background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
      }
    }
    &__title {
      font-size: 22px;
      margin-bottom: 25px;
    }
    &__actions {
      margin-bottom: 0;
    }
  }
}

/deep/ {
  .c-button.close-popover {
    cursor: pointer;
    background: none;
    border: 1px solid #d3d8df;
    height: 38px;
    border-radius: 19px;
    padding: 0 30px;
    color: #000;
    white-space: nowrap;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    position: relative;
    margin: 0 auto;
  }
}
/deep/ {
  .modal-frame .modal-track .scroll-container {
    padding-right: 20px;
  }
} 

.modal-frame__transaction-type-name {
  font-weight: 500;
}

/deep/ {
  .c-input-container-list-item-label {
    width: 100%;
    white-space: unset;
  }
  .c-button-ok {
    display: none!important;
  }

  @include vp-1279 {
    .c-button-ok {
      display: block!important;
    }
  }
}

.show-description {
  height: fit-content;
  margin-top: 15px;
  margin-left: 20px;

  /deep/ {
    .modal-padding {
      padding: 0;
    }
  }

  @include vp-767 {
    margin: -10px 0 20px 10px;
  }
}

.modal-frame {
  &__filial {
    display: flex;
    align-items: center;
    font-size: 15px;

    &-icon {
      width: 12px;
      height: 15px;
      margin-right: 10px;
    }
  }

  &__worker {
    display: flex;
    
    &:not(:first-child) {
      margin-top: 25px;
    }

    &-photo {
      margin-right: 10px;
      pointer-events: none;
    }
    &-text {
      font-size: 15px;
      line-height: 110%;
    }
    &-name {
    }
    &-posts {
      font-size: 13px;
      line-height: 120%;
    }
  }

  &__transaction-type {
    font-size: 15px;
    line-height: 18px;
    margin-top: 20px;

    &-name {
    }
    &-description {
    }
  }

  &__list {
    margin-top: 15px;
    margin-bottom: 25px;

    &-empty {
      font-size: 15px;
      color: #8E9CBB;
    }
    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-search {
      max-width: 565px;
      width: 50%;
      margin-top: 16px;
    }
    &-total {
      background: #F5F7FA;
      border-radius: 80px;
      display: flex;
      align-items: center;
      padding: 7px 20px;

      &-item {
        font-size: 13px;
        line-height: 16px;
        display: flex;
        align-items: center;

        &:not(:last-child) {
          margin-right: 15px;
        }

        &-name {
          color: #8E9CBB;
          margin-right: 5px;
        }
        &-value {
        }
      }
    }
  }
}

.modal-frame__list-main {
  /deep/ {
    .c-table {
      width: 100%;
    }
    .c-table__shadow {
      display: none;
    }
  }
}

.mass-operations-sidesheet {
  /deep/ {
    .shadow-bottom {
      display: none;
    }
  }
}

.scroll-top-button {
  display: none;
}

.sidesheet__wrapper_active {
  .scroll-top-button {
    bottom: 75px!important;
    display: flex;
  }
}

/deep/ {
  .sidesheet__wrapper {
    z-index: 333333;
  }
  .sidesheet__overlay {
    z-index: 333332;
  }
}

</style>
